
import { useAppState } from "src/state";

import { SuperAdminVenueViewSchema } from "src/components/superadmin/venues/SuperAdminVenueViewSchema";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";


export function SuperAdminVenueView() {

    const { currentItem } = useAppState().tenants;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={SuperAdminVenueViewSchema}
            data={currentItem}
            title="Venue Overview"
            icon={Icons.venue}
        />
    );
}